import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralActions = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "single-neutral-actions" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 12,
			cy: 6,
			r: 5.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M2.25,23.25a9.75,9.75,0,0,1,19.5,0"
		})
	]
});
export default SvgSingleNeutralActions;
